import {TextRegular} from '@hm/fundamental'

export interface ConfirmDialogContentProps {
  description?: string
  additionalContent?: React.ReactNode
}

export const ConfirmDialogContent: React.FC<ConfirmDialogContentProps> = ({
  description,
  additionalContent
}) => {
  return (
    <div className="flex flex-row gap-2">
      {description && <TextRegular>{description}</TextRegular>}
      {additionalContent && (
        <div data-cy="confirm_dialog_additional_content">{additionalContent}</div>
      )}
    </div>
  )
}
